module.exports = __webpack_public_path__ + "img/1.99008c9c.png";